import { render, staticRenderFns } from "./home-block.vue?vue&type=template&id=089c0e30&scoped=true&"
import script from "./home-block.js?vue&type=script&lang=js&"
export * from "./home-block.js?vue&type=script&lang=js&"
import style0 from "./home-block.css?vue&type=style&index=0&id=089c0e30&scoped=true&lang=css&"
import style1 from "./home-block-vuetify.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089c0e30",
  null
  
)

export default component.exports